import { render } from "./input.vue?vue&type=template&id=b36bf966&lang=pug"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b36bf966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b36bf966', __exports__)) {
    api.reload('b36bf966', __exports__)
  }
  
  module.hot.accept("./input.vue?vue&type=template&id=b36bf966&lang=pug", () => {
    api.rerender('b36bf966', render)
  })

}


export default __exports__